'use client';

import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';

import { checkContext } from '../context-utils';
import { CommandPaletteType } from './command-palette-types';

export const InitialCommandPaletteState: CommandPaletteType = {
  showCommandPalette: false,
  showPopUp: false,
  vendor: { owner: undefined, employee: undefined },
};

export const CommandPaletteContext = createContext<
  [CommandPaletteType, Dispatch<SetStateAction<CommandPaletteType>>] | null
>(null);

export const setCommandPaletteState = (
  v: [CommandPaletteType, Dispatch<SetStateAction<CommandPaletteType>>] | null,
) => {
  v = checkContext<CommandPaletteType>(v);
  return v[1];
};

export type ProviderProps = {
  commandPaletteContext: CommandPaletteType;
  children: ReactNode;
};

const CommandPaletteProvider: FC<ProviderProps> = ({ commandPaletteContext, children }) => {
  const [appState, dispatch] = useState<CommandPaletteType>(commandPaletteContext);

  return (
    <CommandPaletteContext.Provider value={[appState, dispatch]}>{children}</CommandPaletteContext.Provider>
  );
};

export default CommandPaletteProvider;
